module.exports = {
	"root": "findify-components-search--desktop-actions",
	"block": "findify-components-search--desktop-actions__block",
	"sorting": "findify-components-search--desktop-actions__sorting",
	"query": "findify-components-search--desktop-actions__query",
	"breadcrumbs": "findify-components-search--desktop-actions__breadcrumbs",
	"show-facets": "findify-components-search--desktop-actions__show-facets",
	"showFacets": "findify-components-search--desktop-actions__show-facets"
};